import React from 'react';
import { Box, type BoxProps } from '@chakra-ui/react';

interface PropertyNotificationMarkerProps extends BoxProps {
	hasUnreadNotification: boolean;
	label?: string;
}

/** Compact cross-property signal, matching the unread dot used inside the notifications drawer. */
const PropertyNotificationMarker: React.FC<PropertyNotificationMarkerProps> = ({
	hasUnreadNotification,
	label = 'Unread notifications',
	...boxProps
}) => {
	if (!hasUnreadNotification) return null;

	return (
		<Box role="img" aria-label={label} w={2} h={2} borderRadius="full" bg="red.500" flexShrink={0} {...boxProps} />
	);
};

export default PropertyNotificationMarker;
